import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import avatar from '../../assets/avatar-4.png'
import { Link } from 'react-router-dom'
import Loader from '../../components/Loader'
import {
	GET_CURRENT_CAMPAIGN_RESET,
	USER_GET_ALL_SUBMISSIONS_RESET,
} from '../../redux/types'
import { get_current_campaign_user } from '../../redux/actions/campaignActions'
import { user_get_all_submissions } from '../../redux/actions/submissionActions'
import CampaignSlider from '../../components/CampaignSlider'

const UserDashboardHome = () => {
	const dispatch = useDispatch()

	const userAuth = useSelector((state) => state.userAuth)
	const { loading, userDetail } = userAuth

	const getCurrentCampaign = useSelector((state) => state.getCurrentCampaign)
	const { currentCampaign } = getCurrentCampaign

	const getUserAllSubmissions = useSelector(
		(state) => state.getUserAllSubmissions
	)
	const { userSubmissions } = getUserAllSubmissions

	useEffect(() => {
		dispatch(get_current_campaign_user())
		dispatch(user_get_all_submissions(userDetail.fullName))

		return () => {
			dispatch({ type: GET_CURRENT_CAMPAIGN_RESET })
			dispatch({ type: USER_GET_ALL_SUBMISSIONS_RESET })
		}
	}, [dispatch])

	return (
		<>
			<section className='user_dashboard'>
				{loading ? (
					<Loader />
				) : userDetail ? (
					<div className='container'>
						<div className='row justify-content-center'>
							<div className='col-md-9'>
								<div className='row'>
									<div className='col-md-6'>
										<div className='user_dashboard_dashboard_box'>
											{userDetail.profileImage ? (
												<div className='home_image_box'>
													<img src={userDetail.profileImage} alt='' />
												</div>
											) : (
												<img src={avatar} alt='' />
											)}

											<p>
												{userDetail.firstName} {userDetail.lastName}
											</p>

											<hr />

											<p> {userDetail.email} </p>
										</div>
									</div>

									<div className='col-md-6'>
										<div className='user_dashboard_dashboard_box'>
											<p className='mt-4'> Total No of Submissions </p>
											<h1>
												{userSubmissions &&
													userSubmissions.submissions &&
													userSubmissions.submissions.length}
											</h1>

											<hr />
										</div>
									</div>

									<div className='col-md-6'>
										<div className='user_dashboard_dashboard_box'>
											<p> Current Campaign(s) </p>

											{currentCampaign &&
												currentCampaign.map((e) => (
													<div
														className='d-flex'
														style={{ borderBottom: '1px solid rgba(0,0,0,.1)' }}
													>
														<div className='circle_dot'></div>
														<p> {e.name} </p>
													</div>
												))}
										</div>
									</div>

									<div className='col-md-6'>
										<div className='user_dashboard_dashboard_box'>
											<p className='mt-4'> No of Projects </p>
											<h1> 0 </h1>
										</div>
									</div>

									<div className='col-md-12'>
										<section className='mt-5 mb-5'>
											<CampaignSlider />
										</section>
									</div>
								</div>
							</div>
						</div>
					</div>
				) : (
					'No data to be displayed'
				)}
			</section>
		</>
	)
}

export default UserDashboardHome
